import api from '../lib/api';

const userAnalyticsService = {
    getSentBids: async () => {
        try {
            const response = await api.get('/user/analytics/sent-bids');
            return response.data;
        } catch (error) {
            console.error('Error fetching sent bids:', error.response?.data || error.message);
            throw error;
        }
    },

    getReceivedBids: async () => {
        try {
            const response = await api.get('/user/analytics/received-bids');
            return response.data;
        } catch (error) {
            console.error('Error fetching received bids:', error.response?.data || error.message);
            throw error;
        }
    },

    getMyLots: async () => {
        try {
            const response = await api.get('/user/analytics/my-lots');
            return response.data;
        } catch (error) {
            console.error('Error fetching my lots:', {
                status: error.response?.status,
                data: error.response?.data,
                message: error.message
            });
            throw error;
        }
    },

    getAuctionActivity: async () => {
        try {
            const response = await api.get('/user/analytics/auction-activity');
            return response.data;
        } catch (error) {
            console.error('Error fetching auction activity:', error.response?.data || error.message);
            throw error;
        }
    }
};

export default userAnalyticsService; 